import { createSlice } from '@reduxjs/toolkit';
import { apiUrl } from '../../utils/endPoints/apiUrl';
import { apiRequest } from '../../utils/config/apiRequest';

// Initial filter
const initialFilter = { page: 1, limit: 5, searchQ: '' };

// Initial state
const initialState = {
    isLoading: false,
    shopListing: { rows: [], count: 0, searchQ : '' },
    filter: initialFilter,
};

// Create the slice
const shopSlice = createSlice({
    name: 'shops',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        setBranchListing(state, action) {
            state.shopListing = action.payload;
        },

        setFilter(state, action) {
            state.filter = { ...initialFilter, ...action.payload };
        },
    },
});

// Export actions
export const { startLoading, stopLoading, setBranchListing, setFilter } = shopSlice.actions;

// Async Thunk to fetch the shop list
export const fetchShopList = (query  = {}) => async (dispatch) => {
    try {
        dispatch(startLoading());

        const { data, status } = await apiRequest({
            endUrl: apiUrl.branch.listing,
            query,
        });

        if (status) {
            dispatch(setBranchListing({
                rows: data?.rows,
                count: data?.total,
            }));
        }
    } catch (error) {
        console.error('Error fetching shop list:', error);
    } finally {
        dispatch(stopLoading());
    }
};

// Export the reducer
export default shopSlice.reducer;
